const StatusCards = ({ cards,funnel }) => {
    const getFunnelType = (funnel) =>{
        const styles = {
            'Re-KYC': "sm:w-full",
            'Remittance': "sm:w-1/3",
            'Financing': "sm:w-1/3",
            'Insurance': "sm:w-1/3",
            'Referral': "sm:w-1/2",
        }
        return styles[funnel] || "sm:w-1/4";
    }
    const statusClasses = {
        completed: "border-green-500 bg-white",
        "in-progress": "border-yellow-300 bg-white",
        "not-started": "border-gray-400 text-gray-500 bg-white opacity-60",
    }
    return(
        <div className="flex gap-4">
            {cards.map((card, index) => (
                <div
                    key={index}
                    className={`flex flex-col justify-between w-full ${getFunnelType(funnel)} p-4 rounded-lg shadow-md border-l-4 ${statusClasses[card.status]}`}
                >
                    <div>
                        <h3 className="text-xl font-bold">{card.title}</h3>
                        <p className="mt-2 text-sm">{card.statusLabel}</p>
                    </div>
                </div>
            ))}
        </div>
    )
};
export default StatusCards;